module.exports = __webpack_public_path__ + "img/ignis-glx-constelacion.3eea7a3f.png";